import { render } from "./Loader.vue?vue&type=template&id=b64497dc&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=b64497dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64497dc"]])

export default __exports__